import { Goerli } from "@usedapp/core";

export const ROUTER_ADDRESS = "0xCe7Da094147E86121f1a542ce77019968552FDAA";

export const DAPP_CONFIG = {
  readOnlyChainId: Goerli.chainId,
  readOnlyUrls: {
    [Goerli.chainId]: "https://eth-goerli.g.alchemy.com/v2/NIC2JiZ5fbKYvr3mX_R9OizEa9_Wv5Qa",
  },
};
